import { render } from "./offers-list.vue?vue&type=template&id=d429998c"
import script from "./offers-list.vue?vue&type=script&lang=js"
export * from "./offers-list.vue?vue&type=script&lang=js"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__